<div class="club-tile-desktop-wrapper">
  <div class="club-tile-top-section">
    <div
      class="club-tile-venue-image-wrapper"
      [style.background-image]="backroundImage"
    ></div>
    <div
      class="club-tile-logo-thumbnail-image-wrapper club-tile-logo-thumbnail-image-wrapper-desktop"
    >
      <img
        alt="{{ club?.name }}-thumbnail"
        onerror="this.style.display='none'"
        class="club-tile-logo-thumbnail-image"
        [src]="
          club?.additional_asset
            | imageVariant: {width: 600, height: 40, format: '.webp', quality: 50}
        "
      />
    </div>
  </div>
  <div class="club-tile-box">
    <div class="club-tile-logo-image-wrapper">
      <div class="club-tile-logo-image-content club-tile-logo-image-content-desktop">
        <img
          alt="{{ club?.name }}-logo"
          onerror="this.style.display='none'"
          class="club-tile-logo-image"
          [src]="club?.image | imageVariant: {width: 100, height: 100, quality: 100}"
        />
      </div>
    </div>
    <div class="club-tile-name-desktop">{{ club?.name }}</div>
    <div (click)="clubClicked.emit(club)" class="club-tile-profile">
      {{ 'clubTile.clubProfile' | translate }}
      <tui-svg src="tuiIconArrowRight"></tui-svg>
    </div>
  </div>
</div>

<div class="club-tile-wrapper">
  <div class="club-tile-mobile-content">
    <div class="club-tile-logo-thumbnail-image-wrapper">
      <img
        class="club-tile-logo-thumbnail-image"
        alt="{{ club?.name }}-thumbnail"
        onerror="this.style.display='none'"
        [src]="
          club?.additional_asset
            | imageVariant: {width: 600, height: 40, format: '.webp', quality: 50}
        "
      />
    </div>
    <div class="club-tile-logo-image-content">
      <img
        alt="{{ club?.name }}-logo"
        class="club-tile-logo-image"
        onerror="this.style.display='none'"
        [src]="
          club?.image
            | imageVariant: {width: 100, height: 100, format: '.webp', quality: 100}
        "
      />
    </div>
    <div (click)="clubClicked.emit(club)" class="club-tile-name">{{ club?.name }}</div>
  </div>
</div>
